/**
Author - Venkatesh😉
Git - https://github.com/venkatesh1146
**/

import React, {useEffect} from 'react';

import styled from 'styled-components';
import MuiForm from 'components/MuiForm';

import {ActionButton} from 'screens/commons';

const TradingPreferences = ({formSchema, handleFormSubmit, schema}) => {
  useEffect(() => {
    const stepperContainer = document.querySelector('[class*="meta-form-stepper"]');

    if (!!stepperContainer) {
      stepperContainer.classList.add('stepper');
    }
  }, []);

  return (
    <Container>
      <FormWrapper>
        <MuiForm
          schema={schema.schema}
          onSubmit={(data) => {
            handleFormSubmit(data);
          }}
          buttons={{
            submit: <ActionButton buttonText="Continue" />,
          }}
        />
      </FormWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  scroll-behavior: scroll;
  position: relative;
  overflow-y: scroll;

  @media (max-width: 768px) {
    background: #fff;
  }

  .MuiButton-root{
    font-size: 0.9rem !important;
  }
    
  .mcol{  
    flex:none !important;
    width:fit-content !important;
    margin-top: 0.5rem !important;
    padding-left: 0 !important;

  }

  .footer {
    margin-top: 4rem;
  }
`;

const FormWrapper = styled.div`
  padding: 1rem 1.5rem;
  @media (min-width: 768px) {
    max-width: 80%;
    padding: 2rem 3rem;
  }
`;

export default TradingPreferences;
